// extracted by mini-css-extract-plugin
export default {"content":"UserOnboardingDataPrivacySlide_content__CyiGH"};